import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import InfoOutline from 'material-ui-icons/InfoOutline';
import ArrowForward from 'material-ui-icons/ArrowForward';
import classNames from 'classnames';

import * as _ from 'lodash';
import { errorStyle } from '../styles';
import { textStyle } from '../styles';
import { underlineStyle } from '../styles';
import { ValidationService } from '../validation.service';
import { RegistrationService } from '../registration.service';

class RegistrationStep1 extends Component {
  constructor(props) {
    super(props);

    this.registrationService = new RegistrationService();
    this.validationService = new ValidationService(this.props.intl);

    // we use the state to validate the fields
    this.state = {
      devCounter: 0,
      isTooltipVisible: false,
      validate: {
        username: {
          valid: true,
          errorMessage: '',
        },
        email: {
          valid: true,
          errorMessage: '',
        },
        password: {
          valid: true,
          errorMessage: '',
        },
      },
      showPassword: false,
      memberInfo: null,
    };
  }

  prepop(values) {
    this.props.onChange(values);
  }

  async componentDidMount() {
    setTimeout(() => {
      $('svg').attr('focusable', false);
    }, 500);
    this.setState({
      memberInfo: this.registrationService.parseMemberInfo(MEMBER_INFO),
    });
    setTimeout(() => {
      if (this.state.memberInfo != null) {
        this.prepop(this.state.memberInfo);
      }
    }, 500);
  }

  async onUsernameChange(e) {
    this.props.onChange({ username: e.target.value });
  }

  async isValidUsername(value) {
    let username = await this.validationService.isValidUsername(value);

    // update before calling remote to avoid delay issues
    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        username,
      }),
    });

    if (username.valid) {
      // check if username is taken only if it passes all other checks
      const { intl } = this.props;
      let usernameResponse = await this.registrationService.isUsernameAvailable(
        value
      );
      if (!_.get(usernameResponse.parsed.data, 'username.available', true)) {
        username.valid = false;
        username.errorMessage = intl.formatMessage({
          id: 'validationError.usernameTaken',
        });
      }
    }

    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        username,
      }),
    });
  }

  onEmailChange(e) {
    let value = e.target.value;
    this.props.onChange({ email: value });

    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        email: this.validationService.isValidEmail(value),
      }),
    });
  }

  onPasswordChange(e) {
    let value = e.target.value;
    this.props.onChange({ password: value });
    this.props.onChange({ confirmPassword: value });

    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        password: this.validationService.isValidPassword(
          value,
          this.props.state.username
        ),
      }),
    });
  }

  canSubmit() {
    let errorCount = 0;

    // check errors in the state
    if (_.size(_.get(this.state, 'validate', false))) {
      _.each(this.state.validate, (data) => {
        if (!data.valid) errorCount++;
      });
    }

    // check required fields
    let requiredFields = [
      'firstName',
      'lastName',
      'email',
      'password',
      'username',
    ];

    _.each(requiredFields, (fieldName) => {
      let value = _.get(this.props.state, fieldName, '');
      if (!value.length) {
        errorCount++;
      }
    });

    return !(errorCount || this.props.state.isLoading);
  }

  getErrorText(fieldName) {
    if (
      _.get(this.state.validate, fieldName + '.valid', true) ||
      _.isUndefined(_.get(this.state.validate, fieldName + '.valid', undefined))
    )
      return null;
    else
      return _.get(
        this.state.validate,
        fieldName + '.errorMessage',
        'Invalid value'
      );
  }

  devFillState() {
    // 270
    // bcbsil
    // this.props.onChange({
    //   firstName      : 'Aubree',
    //   lastName       : 'Schumm',
    //   email          : 'johndoe110@test.com',
    //   username       : 'johndoe000' + parseInt(Math.random() * 100000),
    //   password       : 'mdlive123',
    //   confirmPassword: 'mdlive123',
    //   dob            : '05/20/1974',
    //   phone          : 7861231234,
    //   zip            : '29652',
    //   gender         : 'Female',
    //   memberID270       : 'MDL465444970',
    // });
    // 270 dependents
    // this.props.onChange({
    //   firstName: 'Santa',
    //   lastName: 'Schmeler',
    //   email: 'johndoe110@test.com',
    //   username: 'johndoe000' + parseInt(Math.random() * 100000),
    //   password: 'mdlive123',
    //   confirmPassword: 'mdlive123',
    //   dob: '09/18/1985',
    //   phone: 7861231234,
    //   zip: '29652',
    //   gender: 'Male',
    //   primaryFirstName: 'Adolfo',
    //   primaryLastName: 'Gaylord',
    //   memberID270: 'MDL178232252',
    //   primaryGender: 'Male',
    //   primaryDOB: '04/24/1992',
    //   primaryMemberID270: 'MDL92423133',
    // });
    // mdlivetest
    // this.props.onChange({
    //   firstName      : 'Laura',
    //   lastName       : 'Jones',
    //   email          : 'johndoe110@test.com',
    //   username       : 'johndoe000' + parseInt(Math.random() * 100000),
    //   password       : 'mdlive123',
    //   confirmPassword: 'mdlive123',
    //   dob            : '01/01/2000',
    //   phone          : 7861231234,
    //   zip            : '33351',
    //   gender         : 'Male'
    // });
  }

  submit() {
    this.props.goToStep(2);
  }

  getProviderTypes() {
    if (PROVIDER_TYPES) {
      return PROVIDER_TYPES;
    } else {
      return <FormattedMessage id="providerTypes" />;
    }
  }

  handleSignIn() {
    let body = { method: 'signin' };
    let mobileDetected = false;

    if (
      typeof window.Android !== 'undefined' &&
      _.isFunction(window.Android.mobileRegistrationSuccess)
    ) {
      /* eslint @typescript-eslint/camelcase: 0 */
      window.Android.mobileRegistrationSuccess(JSON.stringify(body));
      mobileDetected = true;
    }

    if (
      _.isFunction(
        _.get(
          window,
          'webkit.messageHandlers.mobileRegistrationSuccess.postMessage',
          null
        )
      )
    ) {
      /* eslint @typescript-eslint/camelcase: 0 */
      window.webkit.messageHandlers.mobileRegistrationSuccess.postMessage(
        JSON.stringify(body)
      );
      mobileDetected = true;
    }

    if (!mobileDetected) {
      window.location.href = MDLIVE_LOGIN_URL;
    }
  }

  affiliationsRender() {
    return (
      <div className="registration-step1 row h-100">
        <div className="col col-12 col-md-6 guide-block guide-block--doctor-blue h-100">
          <h1
            onClick={() => {
              // trick to autofill the form
              if (this.state.devCounter >= 3) {
                this.devFillState();
              } else {
                this.setState({ devCounter: this.state.devCounter + 1 });
              }
            }}
          >
            {AFFILIATION_DISPLAY_TITLE || (
              <span className="affiliation-display-name">
                <FormattedMessage
                  id="displayTitle"
                  values={{ affiliationName: AFFILIATION_DISPLAY_NAME }}
                />
              </span>
            )}
          </h1>
          <p>
            {AFFILIATION_DISPLAY_TAGLINE || (
              <FormattedMessage id="displayTagline" />
            )}
          </p>
          <p>
            {AFFILIATION_DISPLAY_INFO || (
              <FormattedMessage
                id="displayInfo"
                values={{ providerTypes: this.getProviderTypes() }}
              />
            )}
          </p>
        </div>

        <div className="col col-12 col-md-6 content-block h-100">
          <h3>
            <FormattedMessage id="subtitle" />
          </h3>
          <div className="form-content container-fluid flex-grow h-100 p-0 m-0">
            <div className="form-group">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="firstName" />}
                value={this.props.state.firstName || ''}
                onChange={(e) =>
                  this.props.onChange({ firstName: e.target.value })
                }
                errorStyle={errorStyle}
                id="first-name"
                disabled={
                  this.state.memberInfo
                    ? this.state.memberInfo.firstName
                    : false
                }
              />
            </div>
            <div className="form-group">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="lastName" />}
                value={this.props.state.lastName || ''}
                onChange={(e) =>
                  this.props.onChange({ lastName: e.target.value })
                }
                errorStyle={errorStyle}
                id="last-name"
                disabled={
                  this.state.memberInfo ? this.state.memberInfo.lastName : false
                }
              />
            </div>

            <div className="form-group">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="email" />}
                type="email"
                errorText={this.getErrorText('email')}
                value={this.props.state.email || ''}
                onChange={(e) => this.onEmailChange(e)}
                errorStyle={errorStyle}
                id="email"
              />
            </div>

            <div className="form-group">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="username" />}
                errorText={this.getErrorText('username')}
                value={this.props.state.username || ''}
                onChange={(e) => this.onUsernameChange(e)}
                onBlur={(e) => this.isValidUsername(e.target.value)}
                errorStyle={errorStyle}
                id="username"
              />
            </div>

            <div className="form-group password-wrapper">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="password" />}
                type={this.state.showPassword ? 'text' : 'password'}
                errorText={this.getErrorText('password')}
                value={this.props.state.password || ''}
                onChange={(e) => {
                  this.onPasswordChange(e);
                }}
                errorStyle={errorStyle}
                id="password"
              />

              <InfoOutline
                className="password-tooltip-btn"
                onClick={() =>
                  this.setState({
                    isTooltipVisible: !this.state.isTooltipVisible,
                  })
                }
                style={{ width: 18, height: 18, color: '#40AD86' }}
              />

              {this.state.isTooltipVisible && (
                <div className="password-tooltip">
                  <ul>
                    <li>
                      <FormattedMessage id="passwordRequirement1" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement2" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement3" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement4" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement5" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement6" />
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <div className="form-checkbox">
              <Checkbox
                onCheck={(e, isChecked) => {
                  this.setState({ showPassword: isChecked });
                }}
                label={<FormattedMessage id="showPassword" />}
                iconStyle={{ right: 0, left: '0px' }}
                id="show-password"
              />
            </div>
          </div>
          <div className="container-fluid form-footer">
            <div>
              <small>
                <FormattedMessage id="alreadyMember" />
                <a
                  href="javascript:void(0)"
                  onClick={() => this.handleSignIn()}
                >
                  <FormattedMessage id="signInHere" />
                </a>
              </small>
            </div>
            <div>
              <RaisedButton
                label={<FormattedMessage id="nextButton" />}
                backgroundColor="var(--affiliation-registration-next-button-color)"
                labelColor="#FFFFFF"
                onClick={() => this.submit()}
                className={classNames('raised-button--rounded', {
                  disabled: !this.canSubmit(),
                })}
                disabled={!this.canSubmit()}
                id="next"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  unaffiliatedRender() {
    return (
      <div className="registration-step1 row h-100">
        <div className="col col-12 col-md-7 guide-block guide-block--doctor-blue h-100">
          <h2
            onClick={() => {
              // trick to autofill the form
              if (this.state.devCounter >= 3) {
                this.devFillState();
              } else {
                this.setState({ devCounter: this.state.devCounter + 1 });
              }
            }}
            className="welcome"
          >
            Welcome to {AFFILIATION_DISPLAY_NAME}.<br />
            Your anytime, anywhere doctor’s office.
          </h2>
          <p>
            {' '}
            Visit a doctor, counselor, psychiatrist or dermatologist by phone,
            secure video, or MDLIVE App. Pediatricians are available 24/7, and
            family members are also eligible.{' '}
          </p>
          <h3 className="register-today">
            Register today
            <ArrowForward
              className="register-arrow"
              style={{ width: 26, height: 26, color: '#ffffff' }}
            />
          </h3>
        </div>

        <div className="col col-12 col-md-5 content-block h-100">
          <h3 className="get-started">Let's get started</h3>
          <div className="form-content container-fluid flex-grow h-100 p-0 m-0">
            <div className="form-group">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="firstName" />}
                value={this.props.state.firstName || ''}
                onChange={(e) =>
                  this.props.onChange({ firstName: e.target.value })
                }
                errorStyle={errorStyle}
                floatingLabelStyle={textStyle}
                underlineStyle={underlineStyle}
                id="first-name"
              />
            </div>
            <div className="form-group">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="lastName" />}
                value={this.props.state.lastName || ''}
                onChange={(e) =>
                  this.props.onChange({ lastName: e.target.value })
                }
                errorStyle={errorStyle}
                floatingLabelStyle={textStyle}
                underlineStyle={underlineStyle}
                id="last-name"
              />
            </div>

            <div className="form-group">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="email" />}
                type="email"
                errorText={this.getErrorText('email')}
                value={this.props.state.email || ''}
                onChange={(e) => this.onEmailChange(e)}
                errorStyle={errorStyle}
                floatingLabelStyle={textStyle}
                underlineStyle={underlineStyle}
                id="email"
              />
            </div>

            <div className="form-group">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="username" />}
                errorText={this.getErrorText('username')}
                value={this.props.state.username || ''}
                onChange={(e) => this.onUsernameChange(e)}
                onBlur={(e) => this.isValidUsername(e.target.value)}
                errorStyle={errorStyle}
                floatingLabelStyle={textStyle}
                underlineStyle={underlineStyle}
                id="username"
              />
            </div>

            <div className="form-group password-wrapper">
              <TextField
                fullWidth={true}
                floatingLabelText={<FormattedMessage id="password" />}
                type={this.state.showPassword ? 'text' : 'password'}
                errorText={this.getErrorText('password')}
                value={this.props.state.password || ''}
                onChange={(e) => {
                  this.onPasswordChange(e);
                }}
                errorStyle={errorStyle}
                floatingLabelStyle={textStyle}
                underlineStyle={underlineStyle}
                id="password"
              />

              <InfoOutline
                className="password-tooltip-btn"
                onClick={() =>
                  this.setState({
                    isTooltipVisible: !this.state.isTooltipVisible,
                  })
                }
                style={{
                  width: 18,
                  height: 18,
                  color: '#40AD86',
                  fontFamily: 'open sans',
                }}
              />

              {this.state.isTooltipVisible && (
                <div className="password-tooltip">
                  <ul>
                    <li>
                      <FormattedMessage id="passwordRequirement1" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement2" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement3" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement4" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement5" />
                    </li>
                    <li>
                      <FormattedMessage id="passwordRequirement6" />
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <div className="form-checkbox">
              <Checkbox
                onCheck={(e, isChecked) => {
                  this.setState({ showPassword: isChecked });
                }}
                label={<FormattedMessage id="showPassword" />}
                iconStyle={{ right: 0, left: '0px' }}
                id="show-password"
              />
            </div>
          </div>
          <div className="container-fluid form-footer">
            <div className="float-right">
              <RaisedButton
                label={<FormattedMessage id="nextButton" />}
                backgroundColor="#0079ff"
                disabledBackgroundColor="#0079ff"
                labelColor="#ffffff"
                disabledLabelColor="#ffffff"
                onClick={() => this.submit()}
                className={classNames('raised-button--rounded', {
                  disabled: !this.canSubmit(),
                })}
                disabled={!this.canSubmit()}
                id="next"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    // disabled temporarily until we start development
    if (AFFILIATION_ID == '') {
      return this.unaffiliatedRender();
    } else {
      return this.affiliationsRender();
    }
  }
}

export default injectIntl(RegistrationStep1);



// WEBPACK FOOTER //
// ./registration-react/components/registration-step1.js